<!--  -->
<template>
  <div>
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="pageType == 'xiuding'">标准制修订服务</el-breadcrumb-item>
        <el-breadcrumb-item v-if="pageType == 'xiangmujianshe'">标准化项目建设服务</el-breadcrumb-item>
        <el-breadcrumb-item v-if="pageType == 'shangpintiaoma'">商品条码服务</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content">
        <div v-if="pageType == 'xiuding'">
            <div class="title">标准制修订服务</div>
            <div class="desc">可提供国家标准、行业标准、地方标准以及团体标准、企业标准的制修订技术指导。国家标准、行业标准需对接相应的标准化技术委员会，省、市级地方标准可协助对接相应的行业主管部门，团体标准需对接行业协会、学会或研究会，企业标准制定后需要上传至“企业标准信息公共服务平台”进行自我声明公开。</div>
            <div class="contact">标准化院联系方式：0533-2302247</div>
        </div>
        <div v-if="pageType == 'xiangmujianshe'">
            <div class="title">标准化项目建设</div>
            <div class="desc">标准化项目建设： 依据标准化试点示范项目建设要求，制定试点示范项目建设方案，协助完善标准体系建设、重要标准制定及标准实施效果评价，为试点示范项目申报、机构建设、技术培训、体系搭建、标准研制、验收准备等提供全过程指导。</div>
            <div class="contact" style="display: flex; align-items: center;justify-content: end;">
                <div style="margin-right: 40px;">市局标准化科：0533-2315973</div>
                <div>市标准化院：0533-2302247</div>
            </div>
        </div>
        <div v-if="pageType == 'shangpintiaoma'">
            <div class="title">商品条码服务</div>
            <div class="desc">
            <div class="fu-title">一、现场申请</div>

                <p>1、现场办理查验营业执照副本原件、公章；</p>

                <p>（一）材料齐全后，受理人网上录入系统成员信息，打印《中国商品条码系统成员登记表》一式三份，申请人核对信息，确认签字，加盖企业公章；</p>

                <p>（二）省物品编码中心在5个工作日内对申请人提供的资料完成初审，对初审合格的，签署意见并报送中国物品编码中心审批；初审不合格的，将申请资料退给申请人并说明理由；</p>

                <p>（三）对初审合格的申请资料，编码中心自收到申请人缴纳的有关费用之日起5个工作日内完成审核程序。对符合规定要求的，向申请人核准注册厂商识别代码（网站公示）；对不符合规定要求的，退回编码分支机构并说明理由；</p>

                <div class="fu-title">二、受理人线上申请；</div>


                <p>线上办理（A）手机应用商店搜索“中国编码”APP或（B）微信搜索中国编码或（C）电脑登录中国物品编码中心官网办理
                    <a href="http://www.ancc.org.cn/" target="_blank">http://www.ancc.org.cn/</a>
                </p>
            </div>
            <img src="../../assets/img/biaozhunchaxun/shangpintiaoma.jpg" alt="">
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
        pageType: '', // 页面类型
    }
  },
  created() {
    this.pageType = this.$route.query.pageType
  },

  watch: {
    $route: function(to, from) {
        console.log('111' + to.query.pageType);
        this.pageType = to.query.pageType
    }
  }
}
</script>

<style lang="less" scoped>
.content {
    margin: 30px 0 50px;
    background-color: #fff;
    padding: 30px 50px 50px;
    box-sizing: border-box;
    .title {
        margin: 30px 0;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
    }
    .desc {
        line-height: 40px;
        text-indent: 2em;
        .fu-title {
            margin: 10px;
            font-weight: bold;
        }
        a {
            color: blue;
            text-decoration: underline;
        }
    }
    img {
        max-width: 100%;
    }
    .contact {
        margin-top: 20px;
        text-align: right;
        font-size: 14px;
    }
}
</style>
